import React, { useEffect } from 'react';
import './Pending.less';
import useClawStatus, {
  ClawStatus,
  PendingStep,
  PENDING_STEP_LABELS,
  PENDING_STEP_PROGRESS,
} from '@src/stores/useClawStatus';
import imgAvatar from '@/assets/claw/logo.png';
import iconCheck from '@/assets/claw/guide/icon-check.svg';
import iconLoading from '@/assets/claw/guide/icon-loading.svg';
import { useClawBotStatus } from '@src/hooks/useClawBotStatus';
import { RefreshButton } from '../RefreshButton';

const ALL_STEPS = [
  PendingStep.PREPARING,
  PendingStep.LOADING_AI,
  PendingStep.INSTALLING,
  PendingStep.STARTING,
  PendingStep.COMPLETE,
];

export const ClawPending: React.FC = () => {
  const { pendingStep, setStatus } = useClawStatus();
  const progress = PENDING_STEP_PROGRESS[pendingStep];

  // 真实数据由 useClawBotStatus 轮询写入 pendingStep；
  // 到达 COMPLETE 后短暂停留再跳转，给用户看到 100% 的反馈
  useEffect(() => {
    if (pendingStep !== PendingStep.COMPLETE) return;
    const timer = setTimeout(() => setStatus(ClawStatus.OPENED), 800);
    return () => clearTimeout(timer);
  }, [pendingStep, setStatus]);
  useClawBotStatus({ polling: true });

  return (
    <div className="claw-pending">
      <RefreshButton />
      {/* Hero Card */}
      <div className="claw-pending-hero">

        <div className="claw-pending-hero-content">
          <h1 className="claw-pending-hero-title">正在为你开通，请稍后</h1>

          <div className="claw-pending-progress-wrap">
            <div className="claw-pending-progress-track" />
            <div
              className="claw-pending-progress-fill"
              style={{ width: `${progress}%` }}
            />
            <div
              className="claw-pending-progress-thumb"
              style={{ left: `calc(${progress}% - 11px)` }}
            >
              <img src={imgAvatar} alt="" />
            </div>
          </div>
          <div className="claw-pending-progress-pct">{progress}%</div>
        </div>
      </div>

      {/* Steps */}
      <div className="claw-pending-steps">
        {ALL_STEPS.map((step) => {
          const isDone = step < pendingStep;
          const isActive = step === pendingStep;
          const isPending = step > pendingStep;
          return (
            <div
              key={step}
              className={`claw-pending-step ${isDone ? 'done' : ''} ${isActive ? 'active' : ''} ${isPending ? 'pending' : ''}`}
            >
              <div className="claw-pending-step-icon">
                {isDone && <img src={iconCheck} alt="done" />}
                {isActive && (
                  <img
                    src={iconLoading}
                    alt="loading"
                    className="claw-pending-step-icon-spin"
                  />
                )}
                {isPending && <span className="claw-pending-step-icon-circle" />}
              </div>
              <span className="claw-pending-step-label">
                {PENDING_STEP_LABELS[step]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClawPending;
